/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import UserPage from 'flarum/common/components/UserPage';
import app from 'flarum/forum/app';
import { slug } from '../../common';
import LinkButton from 'flarum/common/components/LinkButton';

// Make translation calls shorter
const t = (...args) => app.translator.trans(...args);
const prfx = `${slug}.forum.user`;

export default function () {
	extend(UserPage.prototype, 'navItems', function (items) {
		if (!app.forum.attribute(`${slug}.gamification.enabled`)) {
			return;
		}

		items.add(
			'achievements',
			<LinkButton href={app.route('user.achievements', { username: this.user.slug() })} icon="far fa-bullseye-arrow">
				{t(`${prfx}.achievements_nav`)}
				<span className="Button-badge">{this.user.achievementsCount()}</span>
			</LinkButton>,
			300
		);
	});
}
